import { type IdleState, recordActivity } from '../state/idle-state';

import type { Clock } from './types';

const ACTIVITY_EVENTS: Array<keyof DocumentEventMap> = [
	'pointermove',
	'mousemove',
	'keydown',
	'scroll',
	'click',
	'pointerdown',
];

// Attach passive listeners for user-input events (pointer/key/scroll/click).
// On every event, writes the current timestamp into `state.lastActivityAt`.
export class ActivityListener {
	private started = false;
	private handleActivity: (() => void) | undefined;
	private readonly state: IdleState;
	private readonly clock: Clock;

	public constructor(state: IdleState, clock: Clock) {
		this.state = state;
		this.clock = clock;
	}

	public start = () => {
		if (this.started) {
			return;
		}
		if (typeof document === 'undefined') {
			this.started = true;
			return;
		}
		this.started = true;

		this.handleActivity = () => {
			recordActivity(this.state, this.clock());
		};

		const handler = this.handleActivity;
		ACTIVITY_EVENTS.forEach((evt) => {
			document.addEventListener(evt, handler, { passive: true });
		});
	};

	public stop = () => {
		if (!this.started) {
			return;
		}
		this.started = false;
		const handler = this.handleActivity;
		if (handler !== undefined) {
			ACTIVITY_EVENTS.forEach((evt) => {
				document.removeEventListener(evt, handler);
			});
			this.handleActivity = undefined;
		}
	};
}
